import axios from "../../utils/axios";

const state = {
    fleetSummary: null,
    sailinkSummary: null,
    thurayaSummary: null,
    terminalList: null,
    phoneList: null,
    rateplanList: null,
    userList: null,
    groupList: null,
    companyList: null
};

const getters = {
    fleetSummary: (state) => state.fleetSummary,
    sailinkSummary: (state) => state.sailinkSummary,
    thurayaSummary: (state) => state.thurayaSummary,
    terminalList: (state) => state.terminalList,
    phoneList: (state) => state.phoneList,
    rateplanList: (state) => state.rateplanList,
    userList: (state) => state.userList,
    groupList: (state) => state.groupList,
    companyList: (state) => state.companyList
};

const actions = {
    async fetchSummary({commit}, data) {
        const response = await axios.get("/api/v1/navplus/summary", {
            headers: {
                Authorization: "Bearer" + data,
            },
        });
        //console.log('SUMMARY DATA')
        //console.log(response);
        commit("setFleetSummary", response.data.fleetArr.map((item, index) =>
            Object.assign(item, {index})
        ));
        commit("setsailinkSummary", response.data.sailinkArr.map((item, index) =>
            Object.assign(item, {index})
        ));

        commit("setthurayaSummary", response.data.thurayaArr.map((item, index) =>
            Object.assign(item, {index})
        ));

        commit("setterminalList", response.data.terminalArr.map((item, index) =>
            Object.assign(item, {index})
        ));

        commit("setphoneList", response.data.ipArr.map((item, index) =>
            Object.assign(item, {index})
        ));

        commit("setrateplanList", response.data.rpArr.map((item, index) =>
            Object.assign(item, {index})
        ));

        commit("setuserList", response.data.userArr.map((item, index) =>
            Object.assign(item, {index})
        ));

        commit("setgroupList", response.data.grArr.map((item, index) =>
            Object.assign(item, {index})
        ));
        commit("setcompanyList", response.data.ptArr.map((item, index) =>
            Object.assign(item, {index})
        ));
    },

};

const mutations = {
    setFleetSummary: (state, fleetSummary) => (state.fleetSummary = fleetSummary),
    setsailinkSummary: (state, sailinkSummary) => (state.sailinkSummary = sailinkSummary),
    setthurayaSummary: (state, thurayaSummary) => (state.thurayaSummary = thurayaSummary),
    setterminalList: (state, terminalList) => (state.terminalList = terminalList),
    setphoneList: (state, phoneList) => (state.phoneList = phoneList),
    setrateplanList: (state, rateplanList) => (state.rateplanList = rateplanList),
    setuserList: (state, userList) => (state.userList = userList),
    setgroupList: (state, groupList) => (state.groupList = groupList),
    setcompanyList: (state, companyList) => (state.companyList = companyList)
};

export default {
    state,
    getters,
    actions,
    mutations,
};
